export const ratingValue = 4.9;

// Todo: Update to 49 after this task is closed: https://picsart.atlassian.net/browse/PIA-243268
export const TEMPLATES_REQUEST_LIMIT = 50;

export const breadCrumbsInitialData = [
  {
    name: 'templates',
    title: 'Templates',
    item_id: 'templates',
  },
];

export const TEMPLATE_HUB_URL = '/templates';

export const categories = 'categories';

export const categoryBannerImage =
  'https://pastatic.picsart.com/cms-pastatic/945e83bd-6781-43ac-a041-c1d25659cdd1.png';
